export default function FlightMoreOptions(
    $compile,
    $templateRequest,
    userService,
    l10nService,
    authService
) {
    'ngInject';

    return {
        restrict: 'AE',
        scope: {
            options: '=options',
            params: '=params',
            flightsSearch: '=form',
            showOptions: '=show',
            templateUrl: '@templateUrl',
        },
        link: function(scope, element) {
            scope.availableServices = authService.getAvailableServicesFromSessionStorage();
            scope.l10n = l10nService;
            scope.isUSRegion = userService.isUSRegion();
            scope.isUKRegion = userService.isUKRegion();

            /**
             * "KT Charity fares only" option visible only for UK users
             * @type {boolean}
             */
            scope.isFaresOptionVisible = userService.isUKRegion();

            scope.$watch(
                'params.IncludeEuroStar', function(value) {
                    scope.dontIncludeEuroStar = !value;
                }
            );

            scope.euroStarChange = function() {
                scope.params.IncludeEuroStar = !scope.params.IncludeEuroStar;
            };

            scope.formatLabel = function(model) {
                const length = scope.options.airlines.length;
                let code = null;
                for (let i = 0; i < length; i++) {
                    if (model === scope.options.airlines[i].Code) {
                        code = scope.options.airlines[i].Name;
                    }
                }
                return code;
            };

            scope.toggleShowOptions = function() {
                scope.showOptions = !scope.showOptions;
            };

            /**
             * Render directive with provided templateUrl
             */
            $templateRequest(scope.templateUrl).then(function(html) {
              element.html(html).show();
              $compile(element.contents())(scope);
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/directives/train-more-options-directive.js